import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StoreTearsheetProductDetailsView from "@store/Components/Store/StoreTearsheetProductDetailsView";
import { minimalFontOnlyToolbarButtons } from "@store/utilities/richTextToolbars";
import * as React from "react";
import { connect } from "react-redux";

export interface StoreDetailsViewTearsheetProps {
    fullWidthContent: string;
    bottomLeftcontent: string;
    bottomRightContent: string;
}
const enum fields {
    fullWidthContent = "fullWidthContent",
    bottomLeftcontent = "bottomLeftcontent",
    bottomRightContent = "bottomRightContent",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.fullWidthContent]: string;
        [fields.bottomLeftcontent]: string;
        [fields.bottomRightContent]: string;
    };
}

type Props = OwnProps & WidgetProps;

const TearsheetProductDetailsView: React.FC<Props> = props => {
    const tearsheetContent = {
        fullWidthContent: props.fields.fullWidthContent,
        bottomLeftcontent: props.fields.bottomLeftcontent,
        bottomRightContent: props.fields.bottomRightContent,
    };
    return <StoreTearsheetProductDetailsView {...tearsheetContent} />;
};

const widgetModule: WidgetModule = {
    component: connect()(TearsheetProductDetailsView),
    definition: {
        displayName: "Tearsheet",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.fullWidthContent,
                displayName: "Main Bottom Content",
                editorTemplate: "RichTextField",
                expandedToolbarButtons: minimalFontOnlyToolbarButtons,
                defaultValue: "",
                fieldType: "General",
                tooltip: "Visible only when printing",
            },
            {
                name: fields.bottomLeftcontent,
                displayName: "Left Bottom Content",
                editorTemplate: "RichTextField",
                expandedToolbarButtons: minimalFontOnlyToolbarButtons,
                defaultValue: "",
                fieldType: "General",
                tooltip: "Visible only when printing",
            },
            {
                name: fields.bottomRightContent,
                displayName: "Right Bottom Content",
                editorTemplate: "RichTextField",
                expandedToolbarButtons: minimalFontOnlyToolbarButtons,
                defaultValue: "",
                fieldType: "General",
                tooltip: "Visible only when printing",
            },
        ],
    },
};

export default widgetModule;
